import React, { useState } from 'react';
import { BsTruck, BsTruckFlatbed } from "react-icons/bs";

import styled from 'styled-components';
import { addNotification } from '../../../../supplementary_components/store';
import { useBoardStore } from '../../../boardStore';
import { getFormattedTimePassed } from './currentState';

// ${props => props.$thirdPartyTrailer ?`
//                     color:var(--darkPurple);
//                 `:`
                    
//                 `}
const TrailerContainer = styled.div`
    *{
        -webkit-transition: var(--trainsion-with-delay);
        -moz-transition:var(--trainsion-with-delay);
        -o-transition:var(--trainsion-with-delay);
        transition:var(--trainsion-with-delay);
        transition-delay:var(--trainsion-delay);
    }
    width:4rem;
    .changeOnHoverContent{
        &>span{
            border-radius: 0.5rem 0.5rem 0 0;
            display:flex;
            justify-content:center;
            align-items:center;
            padding:0.7rem;
            
            &>svg{
                color:var(--dark-gray);
            }
            &.thirdPartyTrailer, &.sisterCompanyTrailer{
                &>svg{
                    width:2.4rem;
                    height:2.4rem;
                    padding: 0.4rem;
                    overflow:visible;
                    border-radius:0.4rem;
                }  
            }
            &.thirdPartyTrailer{
                &>svg{  
                    background-color:rgba(var(--inProgressPurpleRGB), 0.3);
                }
                
            }
            &.sisterCompanyTrailer{
                &>svg{
                    background-color:rgba(var(--inProgressBlueRGB), 0.3);
                }
            }
            &.detachedTrailer{
                &>svg{
                    // background-color:rgba(var(--alertRGB), 0.3);
                    color:var(--alert-color);
                }
            }
                
            &:not(&.thirdPartyTrailer, &.sisterCompanyTrailer){
                &>svg{
                    width:1.6rem;
                    height:1.6rem;
                }
            }
        }
        .showOnHoverContent{
            background-color:var(--bg);
            position:absolute;
            box-shadow: var(--on-hover-visible-object-TOPLESS-shadow);
            border-radius: 0 0.5rem 0.5rem 0.5rem;
            height:0;
            overflow:hidden;
            z-index:10;
            display:flex;
            flex-direction:column;
            align-items:flex-end;
            justify-content:center;
            white-space:nowrap;
        }
        
    }
    :hover{
        z-index:3;
        .changeOnHoverContent{
            &>span{
                background-color:var(--extra-extra-light-gray);
                box-shadow: var(--on-hover-visible-object-shadow);
                
                
            }
            &>.showOnHoverContent{
                padding:1rem 1.5rem;
                height:3.25rem;
                &.hasAge{
                    padding:1.35rem 1.5rem 1rem;
                    height:3.55rem;
                }
            }
        }
        
    }
`;

const TrailerLastUpdatedAge = styled.span`
    position:absolute;
    top:0.45rem;
    right:1.5rem;
    font-size:0.65rem;
    line-height:1;
    font-weight:600;
    color:var(--light-gray);
    pointer-events:none;
`;

const CopyableTrailerNumber = styled.span`
    cursor: pointer;
    color: var(--gray);
    font-weight: 600;
    /* Beat TrailerContainer * delayed transition so hover color is immediate. */
    transition: color 0.15s ease !important;
    transition-delay: 0s !important;

    &:hover,
    &:focus-visible {
        color: var(--main-color);
    }
`;

function copyLocationToClipboard(text) {
    if (!text) return;
    navigator.clipboard.writeText(text).then(() => {
        addNotification({ message: 'Location copied', type: 'success' });
    }).catch(() => {
        addNotification({ message: 'Failed to copy location', type: 'alert' });
    });
}

/** Compute once on hover — no store subscription / per-minute re-renders. */
function formatTrailerAge(lastUpdatedIso) {
    if (!lastUpdatedIso) return null;
    const now = useBoardStore.getState().getLiveCurrentTime?.();
    if (!now) return null;
    const result = getFormattedTimePassed(lastUpdatedIso, now);
    if (typeof result === 'string') return result.replace(/^Since /, '');
    if (result?.lbl) return result.lbl.replace(/^For /, '');
    return null;
}

export const MB_TRAILER = ({trailerData, companyId}) => {
    const lastLocation = trailerData?.lastLocation;
    const lastUpdated = trailerData?.lastUpdated;
    const canCopyLocation = Boolean(trailerData && lastLocation);
    const [ageLabel, setAgeLabel] = useState(null);

    return <TrailerContainer
        onMouseEnter={() => setAgeLabel(formatTrailerAge(lastUpdated))}
        onMouseLeave={() => setAgeLabel(null)}
    >
        <div className="changeOnHoverContent"  >
            <span className={`${trailerData ? trailerData.potentiallyDetached ? "detachedTrailer" : trailerData.thirdPartyTrailer ? "thirdPartyTrailer" : trailerData.companyId !== companyId ? "sisterCompanyTrailer" : "" : ""}`} >
                {trailerData ? <BsTruck /> : <BsTruckFlatbed />}
                
            </span>
            <div className={`showOnHoverContent${ageLabel ? ' hasAge' : ''}`}>
                {ageLabel ? <TrailerLastUpdatedAge>{ageLabel}</TrailerLastUpdatedAge> : null}
                {canCopyLocation ? (
                    <CopyableTrailerNumber
                        className="trailerNumberHoldingContainer"
                        role="button"
                        tabIndex={0}
                        title="Copy trailer location"
                        onClick={() => copyLocationToClipboard(lastLocation)}
                        onKeyDown={(e) => {
                            if (e.key === 'Enter' || e.key === ' ') {
                                e.preventDefault();
                                copyLocationToClipboard(lastLocation);
                            }
                        }}
                    >
                        {trailerData.trailerNumber}
                    </CopyableTrailerNumber>
                ) : (
                    <span className="standard_text trailerNumberHoldingContainer">
                        {trailerData ? trailerData.trailerNumber : "Bobtail"}
                    </span>
                )}
            </div>
        </div>
    </TrailerContainer>
}
